import React from 'react';

const GalleryTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            {
                props.item.images[0] && props.item.images[0].url ?
                    <td>
                        <img src={props.item.images[0].url} alt="" />
                    </td>
                    : 
                    <td>
                        <img src={window.location.origin + "/assets/images/notavailablef2.jpg"} alt="" />
                    </td>
            }
            <td>
                {props.item.name}
            </td>
        </tr>
    );
};

export default GalleryTable;